<div class="w-full space-y-6">
  <!-- Header Section -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Users Management</h1>
      <p class="text-gray-600 mt-1">Manage users, roles, and tenant access</p>
    </div>
    <p-button label="Add User" (click)="addUser()"
      icon="pi pi-plus" class="bg-sky-500 text-white px-4 py-2 rounded-md">
    </p-button>
  </div>

  <!-- Stats Cards -->
  <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
    <div class="bg-white p-6 rounded-xl shadow-lg border border-sky-100">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-600">Total Users</p>
          <p class="text-2xl font-bold text-gray-800">{{ totalUsers }}</p>
        </div>
        <div class="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center">
          <i class="pi pi-users text-sky-600 text-xl"></i>
        </div>
      </div>
    </div>

    <div class="bg-white p-6 rounded-xl shadow-lg border border-sky-100">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-600">Active Users</p>
          <p class="text-2xl font-bold text-green-600">{{ totalActiveUsers }}</p>
        </div>
        <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
          <i class="pi pi-check-circle text-green-600 text-xl"></i>
        </div>
      </div>
    </div>

    <div class="bg-white p-6 rounded-xl shadow-lg border border-sky-100">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-600">Administrators</p>
          <p class="text-2xl font-bold text-red-600">{{ totalAdmins }}</p>
        </div>
        <div class="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
          <i class="pi pi-shield text-red-600 text-xl"></i>
        </div>
      </div>
    </div>

    <div class="bg-white p-6 rounded-xl shadow-lg border border-sky-100">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-600">Active Tenants</p>
          <p class="text-2xl font-bold text-blue-600">{{ totalTenants }}</p>
        </div>
        <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
          <i class="pi pi-building text-blue-600 text-xl"></i>
        </div>
      </div>
    </div>
  </div>

 
  <!-- Users List -->
  <div class="bg-white rounded-xl shadow-lg border border-sky-100 overflow-hidden">
    <div class="px-6 py-4 bg-gradient-to-r from-sky-50 to-blue-50 border-b border-sky-100">
      <h2 class="text-lg font-semibold text-gray-800">Users ({{ totalUsers }})</h2>
    </div>
    
    <div class="divide-y divide-gray-200">

      <div 
        *ngFor="let user of usersList" 
        class="p-6 hover:bg-sky-50 transition-colors cursor-pointer"
        (click)="selectUser(user)">
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <div class="flex items-center space-x-4">
              <!-- User Avatar -->
              <p-avatar 
                [label]="getInitials(user.firstName, user.lastName)"
                styleClass="bg-sky-100 text-sky-600 text-lg font-semibold"
                size="large"
                shape="circle">
              </p-avatar>
              
              <!-- User Details -->
              <div class="flex-1">
                <div class="flex items-center space-x-3 mb-2">
                  <h3 class="text-lg font-semibold text-gray-800">{{ user.firstName }} {{ user.lastName }}</h3>
                  <span [class]="'px-2 py-1 rounded-full text-xs font-medium ' + getStatusBadgeClass(user.userStatus)">
                    {{ user.userStatus }}
                  </span>
                </div>
                
                <div class="flex items-center space-x-4 text-sm text-gray-600">
                  <span class="flex items-center">
                    <i class="pi pi-user mr-1"></i>
                    {{ user.userType | titlecase }}
                  </span>
                  <span class="flex items-center">
                    <i class="pi pi-clock mr-1"></i>
                    Created: {{ user.createdAt | date:'dd/MMM/yyyy HH:mm' }}
                  </span>
                  <span *ngIf="user.lastActivity" class="flex items-center">
                    <i class="pi pi-history mr-1"></i>
                    <!-- Duration: {{ getSessionDuration(user.sessionStarted, user.lastActivity) }} -->
                  </span>
                </div>
              </div>
              <div class="flex items-center space-x-4 text-md text-gray-600">
                <span class="flex items-center">
                  <i [class]="'pi pi-whatsapp mr-1 ' + getStatusBadgeClass(user.mobileVerified)"></i>
                  {{ user.mobileNumber }}
                </span>
              </div>
              <div class="flex items-center space-x-4 text-md text-gray-600">
                <span class="flex items-center">
                  <i [class]="'pi pi-envelope mr-1 ' + getStatusBadgeClass(user.emailVerified)"></i>
                  {{ user.userEmail }}
                </span>
              </div>
            </div>
          </div>
  
          
          <!-- Arrow Icon -->
          <div class="ml-4">
            <i class="pi pi-chevron-right text-gray-400"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Right Side Drawer -->
<div class="fixed inset-0 z-50 overflow-hidden" [class.hidden]="!drawerOpen">
  <div class="absolute inset-0 bg-black bg-opacity-50 transition-opacity" (click)="closeDrawer()" ></div>
  
  <!-- Drawer -->
  <div class="absolute right-0 top-0 h-full w-full max-w-lg bg-white shadow-2xl transform transition-transform">
    <div class="flex flex-col h-full">
      <!-- Drawer Header -->
      <div class="px-6 py-4 bg-gradient-to-r from-sky-500 to-sky-600 text-white">
        <div class="flex items-center justify-between">
          <h2 class="text-xl font-semibold">
            {{ formMode == 'add' ? 'Invite User' : 'User Details' }}
          </h2>
          <button 
            (click)="closeDrawer()"
            class="p-2 hover:bg-sky-600 rounded-lg transition-colors"
          >
            <i class="pi pi-times text-xl"></i>
          </button>
        </div>
      </div>
      
      <!-- Drawer Content -->
      <div class="flex-1 overflow-y-auto p-6" >
        <!-- User Info -->
        <div class="mb-6">
          <form [formGroup]="userForm">
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-1/2">
                <label class="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                <input pInputText formControlName="firstName" class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400" />
              </div>
              <div class="w-1/2">
                <label class="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                <input pInputText formControlName="lastName" class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400" />
              </div>
            </div>
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input pInputText formControlName="userEmail" class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400" />
              </div>
            </div>
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 mb-2">Mobile</label>
                <input pInputText formControlName="mobileNumber" class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400" />
              </div>
            </div>
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 mb-2">User Password</label>
                <p-inputgroup>
                  <p-password formControlName="userPassword" [toggleMask]="true"  [feedback]="false"
                    class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400" />
                  <p-inputgroup-addon>
                      <p-button icon="pi pi-sync" title="click to generate password" severity="secondary" class="bg-sky-400 text-white px-4 py-2 rounded-md" (click)="generatePassword()" />
                  </p-inputgroup-addon>
                </p-inputgroup>
              </div>
            </div>
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 mb-2">User Type</label>
                <p-select [options]="userTypeOptions" formControlName="userType" optionLabel="label" optionValue="value" placeholder="Select User Type"
                    class="w-full px-2 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition duration-200 text-gray-700 placeholder-gray-400"></p-select>
              </div>
            </div>
            <div class="flex items-center space-x-4 mb-4">
              <div class="w-full">
                <label class="block text-sm font-medium text-gray-700 mb-2">Tenants</label>
              </div>
            </div>
            <div class="flex justify-end">
              @if(formMode == 'add') {
               <p-button label="Send Invitation" icon="pi pi-send" class="bg-sky-500 text-white px-4 py-2 rounded-md" (onClick)="sendInvitation()"></p-button>
              } @else {
              <p-button label="Update User Details" icon="pi pi-check" class="bg-sky-500 text-white px-4 py-2 rounded-md" (onClick)="updateUser()"></p-button>
              }
            </div>
           
          </form>
        </div>
      </div>
    </div>
  </div>
</div>